import React from 'react';
import { Link, withRouter } from "react-router-dom";
import MobileDetect from "mobile-detect"
import '../css/header.css'


class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mobToggleBtnClassName: "fa fa-bars",
            logo: "",
            storeId: "",
            couponLink: "",
            orderLink: "",
            mailLink: "",
            enableAbout: 0,
            enableOrder: 0,
            enableCoupon: 0,
            enableMail: 0,
            enableFaq: 0,
            aboutTitle: "",
            orderTitle: "",
            couponTitle: "",
            mailTitle: "",
            faqTitle: "",
            logoWidth: "",
            mlogoWidth: "",
            mlogo: ""
        };
        this.handleMobToggleClick = this.handleMobToggleClick.bind(this);
        this.handleOverlyClick = this.handleOverlyClick.bind(this);
    }


    checkNavActive() {
        if (window.$('body').hasClass('mobile-nav-active')) {
            window.$('body').removeClass('mobile-nav-active');
            window.$('#mobile-nav-toggle i').toggleClass('fa-times fa-bars');
            window.$('#mobile-body-overly').fadeOut();
        } else {
            window.$('body').toggleClass('mobile-nav-active');
            window.$('#mobile-body-overly').toggle();
        }
    }

    handleMobToggleClick(event) {
        this.setState({
            mobToggleBtnClassName: (this.state.mobToggleBtnClassName === 'fa fa-bars') ? 'fa fa-times' : 'fa fa-bars'
        })

        this.checkNavActive()
    }

    handleOverlyClick(event) {
        this.handleMobToggleClick()
    }


    handleLinkClick(target) {
        console.log('change')
        console.log(target)
        if (target === "mail0" || target === "coupon0" || target === "order0") {

        } else {
            this.handleMobToggleClick()
        }

        if (target === 'index') {
            this.props.history.push('/')
        } else if (target === 'about') {
            this.props.history.push('/about')
        } else if (target === 'faq') {
            this.props.history.push('/faq')
        } else if (target === 'order' || target === 'order0') {
            if (this.state.orderLink !== "") {
                //window.location.href = this.state.orderLink;
                window.open(this.state.orderLink)
            } else {
                this.props.history.push('/order')
            }
        } else if (target === 'coupon' || target === 'coupon0') {
            if (this.state.couponLink !== "") {
                //window.location.href = this.state.couponLink;
                window.open(this.state.couponLink)
            }
        } else if (target === 'mail' || target === 'mail0') {
            if (this.state.mailLink !== "") {
                //window.location.href = this.state.mailLink;
                window.open(this.state.mailLink)
            } else {
                //window.location.href = window.location.protocol + "//store.tagfans.com/index.html#page_station?mail=true&o=" + this.state.storeId + "&bg=null"
                //let url = window.location.protocol + "//store.tagfans.com/index.html#page_station?mail=true&o=" + this.state.storeId + "&bg=null";
                let url = "https://eat.tagfans.com/#page_join?o=7827&id=33811&viewType=station&orderHistory=1"; //window.location.protocol + "//eat.tagfans.com/#page_join?o=7827&id=33811&viewType=station&orderHistory=1";
                window.open(url)
            }
        }
    }


    componentWillMount() {


        const device = new MobileDetect(window.navigator.userAgent);
        

        if (this.props.context !== undefined && this.props.context !== "") {
            let logo = "";
            let storeId = "";
            let couponLink = "";
            let mailLink = "";
            let enableAbout = 0;
            let enableOrder = 0;
            let enableCoupon = 0;
            let enableMail = 0;
            let enableFaq = 0;
            let aboutTitle = "";
            let orderTitle = "";
            let couponTitle = "";
            let mailTitle = "";
            let faqTitle = "";
            let logoWidth = "";
            let mlogoWidth = "";
            let mlogo = "";

            if (this.props.context.logo !== undefined && this.props.context.logo !== "") {
                logo = this.props.context.logo;
            }

            if (this.props.context.logoWidth !== undefined && this.props.context.logoWidth !== "") {
                logoWidth = this.props.context.logoWidth;
            }

            if (this.props.context.mlogoWidth !== undefined && this.props.context.mlogoWidth !== "") {
                mlogoWidth = this.props.context.mlogoWidth;
            }

            if (this.props.context.mlogo !== undefined && this.props.context.mlogo !== "") {
                mlogo = this.props.context.mlogo;
            }

            if (this.props.context.linkId !== undefined && this.props.context.linkId !== undefined) {
                storeId = this.props.context.linkId;
            }

            if (this.props.context.about !== undefined && this.props.context.about !== "") {
                if (this.props.context.about.enableLink !== undefined && this.props.context.about.enableLink === "1") {
                    enableAbout = 1;
                }
                if (this.props.context.about.linkTitle !== undefined && this.props.context.about.linkTitle !== "") {
                    aboutTitle = this.props.context.about.linkTitle;
                }
            }

            if (this.props.context.order !== undefined && this.props.context.order !== "") {
                if (this.props.context.order.enableLink !== undefined && this.props.context.order.enableLink === "1") {
                    enableOrder = 1
                }
                if (this.props.context.order.linkTitle !== undefined && this.props.context.order.linkTitle !== "") {
                    orderTitle = this.props.context.order.linkTitle;
                }
            }

            if (this.props.context.faq !== undefined && this.props.context.faq !== "") {
                if (this.props.context.faq.enableLink !== undefined && this.props.context.faq.enableLink === "1") {
                    enableFaq = 1
                }
                if (this.props.context.faq.linkTitle !== undefined && this.props.context.faq.linkTitle !== "") {
                    faqTitle = this.props.context.faq.linkTitle;
                }
            }

            if (this.props.context.mailLink !== undefined && this.props.context.mailLink !== "") {
                if (this.props.context.mailLink.enableLink !== undefined && this.props.context.mailLink.enableLink === "1") {
                    enableMail = 1
                }
                if (this.props.context.mailLink.linkTitle !== undefined && this.props.context.mailLink.linkTitle !== "") {
                    mailTitle = this.props.context.mailLink.linkTitle;
                }
                if (this.props.context.mailLink.linkUrl !== undefined && this.props.context.mailLink.linkUrl !== "") {
                    mailLink = this.props.context.mailLink.linkUrl;
                }
            }

            if (this.props.context.couponLink !== undefined && this.props.context.couponLink !== "") {
                if (this.props.context.couponLink.enableLink !== undefined && this.props.context.couponLink.enableLink === "1") {
                    enableCoupon = 1
                }
                if (this.props.context.couponLink.linkTitle !== undefined && this.props.context.couponLink.linkTitle !== "") {
                    couponTitle = this.props.context.couponLink.linkTitle;
                }
                if (this.props.context.couponLink.linkUrl !== undefined && this.props.context.couponLink.linkUrl !== "") {
                    couponLink = this.props.context.couponLink.linkUrl;
                }
            }



            this.setState({
                logo: logo,
                storeId: storeId,
                couponLink: couponLink,
                mailLink: mailLink,
                enableAbout: enableAbout,
                enableOrder: enableOrder,
                enableCoupon: enableCoupon,
                enableMail: enableMail,
                enableFaq: enableFaq,
                aboutTitle: aboutTitle,
                orderTitle: orderTitle,
                couponTitle: couponTitle,
                mailTitle: mailTitle,
                faqTitle: faqTitle,
                logoWidth: logoWidth,
                device: device,
                mlogoWidth: mlogoWidth,
                mlogo: mlogo
            })
        }
    }


    getLink(target, type) {
        let link;
        switch (target) {
            case "about":
                if (this.state.enableAbout === 1) {
                    let text = "品牌簡介";
                    if (this.state.aboutTitle !== "") {
                        text = this.state.aboutTitle;
                    }
                    if (type === 1) {
                        link = (<li><Link to="/about" >{text}</Link></li>)
                    } else {
                        link = (<li><a onClick={() => this.handleLinkClick('about')}>{text}</a></li>)
                    }

                }
                break;

            case "faq":
                if (this.state.enableFaq === 1) {
                    let text = "常見問題";
                    if (this.state.faqTitle !== "") {
                        text = this.state.faqTitle;
                    }
                    if (type === 1) {
                        link = (<li><Link to="/faq" >{text}</Link></li>)
                    } else {
                        link = (<li><a onClick={() => this.handleLinkClick('faq')}>{text}</a></li>)
                    }
                }
                break;

            case "order":
                if (this.state.enableOrder === 1) {
                    let text = "開始訂餐";
                    if (this.state.orderTitle !== "") {
                        text = this.state.orderTitle;
                    }
                    if (type === 1) {
                        link = (<li><a className="link-a" onClick={() => this.handleLinkClick('order0')}>{text}</a></li>)
                    } else {
                        link = (<li><a onClick={() => this.handleLinkClick('order')}>{text}</a></li>)
                    }
                }
                break;

            case "coupon":
                if (this.state.enableCoupon === 1) {
                    let text = "我的優惠卷";
                    if (this.state.couponTitle !== "") {
                        text = this.state.couponTitle;
                    }
                    if (type === 1) {
                        link = (<li><a className="link-a" onClick={() => this.handleLinkClick('coupon0')}>{text}</a></li>)
                    } else {
                        link = (<li><a onClick={() => this.handleLinkClick('coupon')}>{text}</a></li>)
                    }

                }
                break;

            case "mail":
                if (this.state.enableMail === 1) {
                    let text = "查詢訂單";
                    if (this.state.mailTitle !== "") {
                        text = this.state.mailTitle;
                    }
                    if (type === 1) {
                        link = (<li><a className="link-a" onClick={() => this.handleLinkClick('mail0')}>{text}</a></li>)
                    } else {
                        link = (<li><a onClick={() => this.handleLinkClick('mail')}>{text}</a></li>)
                    }

                }
                break;
        }

        return link;

    }


    render() {

        let imgStyle = {};
        let logoSrc = ""
        if (this.state.device && this.state.device.os && (this.state.device.os() === 'iOS' || this.state.device.os() === 'AndroidOS')) {
            if (this.state.mlogo) {
                logoSrc = this.state.mlogo;
            } else {
                logoSrc = this.state.logo;
            }

            console.log("mlogoWidth:", this.state.mlogoWidth)
            if (this.state.mlogoWidth && this.state.mlogoWidth !== "") {
                imgStyle.width = this.state.mlogoWidth;
            }
        } else {
            logoSrc = this.state.logo;
            console.log("logoWidth:", this.state.logoWidth)
            if (this.state.logoWidth && this.state.logoWidth !== "") {
                imgStyle.width = this.state.logoWidth;
            }
        }
        

        return (
            <div className="header-frame">
                <button type="button" id="mobile-nav-toggle" onClick={this.handleMobToggleClick}><i className={this.state.mobToggleBtnClassName}></i></button>
                <header id="header">
                    <div className="container-fluid">
                        <div id="logo" className="pull-left">
                            <Link to="/" className="scrollto"><img src={logoSrc} style={imgStyle} /></Link>
                        </div>
                        <nav id="nav-menu-container">
                            <ul className="nav-menu">
                                <li className="menu-active"><Link to="/" >首頁</Link></li>
                                {this.getLink('about', 1)}
                                {this.getLink('faq', 1)}
                                {this.getLink('order', 1)}
                                {this.getLink('coupon', 1)}
                                {this.getLink('mail', 1)}
                            </ul>
                        </nav>
                    </div>
                </header>

                <div className="mobile-nav-frame">
                    <nav id="mobile-nav">
                        <ul className="" id="">
                            <li className="menu-active"><a onClick={() => this.handleLinkClick('index')}>首頁</a></li>
                            {this.getLink('about', 2)}
                            {this.getLink('faq', 2)}
                            {this.getLink('order', 2)}
                            {this.getLink('coupon', 2)}
                            {this.getLink('mail', 2)}
                        </ul>
                    </nav>
                    <div id="mobile-body-overly" onClick={this.handleOverlyClick}></div>
                </div>
            </div>
        )
    }
}


export default withRouter(Header)


// WEBPACK FOOTER //
// ./src/component/header.js